/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import { Redirect } from 'react-router-dom'
import { Auth } from '@src/redux/reducers'
import { Routes } from '@src/constants'
import { useFeatureFlagsContext } from '@src/modules/feature.flags/context'

export interface AccountProps {
  tenant: Auth.Tenant
  hideDashboard?: boolean
}

export const Account = (props: AccountProps) => {
  const { CAM_PERM_20220804_HIDE_DASHBOARD } = useFeatureFlagsContext()
  const hideDashboard = CAM_PERM_20220804_HIDE_DASHBOARD?.response?.value
  let retVal = <Redirect to={`/setup`} />
  if (
    props.tenant &&
    props.tenant.account_info &&
    props.tenant.account_info.length > 0
  ) {
    if (!hideDashboard) {
      retVal = <Redirect to={Routes.defaultPage} />
    } else {
      retVal = <Redirect to={'/sources/cloud'} />
    }
  }
  return retVal
}
